import React, { useState } from 'react';
import { ShoppingBag, Lock, Image, Video, File, Plus, DollarSign, Eye, Download, Clock, Star, Gift, Mic, BarChart2, TrendingUp, ArrowUpRight, Camera, Users, Search, Filter, Sparkles } from 'lucide-react';
export function ContentStoreSection() {
  const [activeTab, setActiveTab] = useState('content-packs');
  const [showUploadModal, setShowUploadModal] = useState(false);
  // Sample data for content packs
  const contentPacks = [{
    id: '1',
    title: 'Summer Beach Collection',
    description: 'Hot beach photoshoot with 25 exclusive images',
    price: 29.99,
    type: 'photo',
    itemCount: 25,
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vHHEJMHRsXTLdBi469pjxd/image.png',
    sales: 48,
    rating: 4.8,
    featured: true
  }, {
    id: '2',
    title: 'Bedroom Secrets Video Set',
    description: 'Intimate bedroom video collection with 5 exclusive videos',
    price: 49.99,
    type: 'video',
    itemCount: 5,
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vHHEJMHRsXTLdBi469pjxd/image.png',
    sales: 32,
    rating: 4.9,
    featured: true
  }, {
    id: '3',
    title: 'Lingerie Try-On Haul',
    description: 'Watch me try on my favorite lingerie pieces',
    price: 24.99,
    type: 'video',
    itemCount: 1,
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vHHEJMHRsXTLdBi469pjxd/image.png',
    sales: 65,
    rating: 4.7,
    featured: false
  }, {
    id: '4',
    title: 'ASMR Whispers Collection',
    description: 'Intimate ASMR audio recordings just for you',
    price: 19.99,
    type: 'audio',
    itemCount: 10,
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vHHEJMHRsXTLdBi469pjxd/image.png',
    sales: 27,
    rating: 4.6,
    featured: false
  }, {
    id: '5',
    title: 'Shower Time Exclusive',
    description: 'Steamy shower video with multiple angles',
    price: 34.99,
    type: 'video',
    itemCount: 3,
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vHHEJMHRsXTLdBi469pjxd/image.png',
    sales: 42,
    rating: 4.9,
    featured: true
  }, {
    id: '6',
    title: 'Cosplay Fantasy Collection',
    description: 'Your favorite characters brought to life',
    price: 39.99,
    type: 'photo',
    itemCount: 30,
    thumbnail: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vHHEJMHRsXTLdBi469pjxd/image.png',
    sales: 38,
    rating: 4.7,
    featured: false
  }];
  const topSellingContent = [{
    id: '1',
    title: 'Shower Time Exclusive',
    sales: 42,
    revenue: 1469.58,
    growth: '+15%'
  }, {
    id: '3',
    title: 'Lingerie Try-On Haul',
    sales: 65,
    revenue: 1624.35,
    growth: '+28%'
  }, {
    id: '2',
    title: 'Bedroom Secrets Video Set',
    sales: 32,
    revenue: 1599.68,
    growth: '+8%'
  }];
  const contentSuggestions = [{
    title: 'Morning Routine Video',
    description: 'Fans are 65% more likely to purchase morning routine content',
    match: 92
  }, {
    title: 'Workout Session Photos',
    description: 'Fitness content has grown 45% in popularity this month',
    match: 85
  }, {
    title: 'ASMR Roleplay Series',
    description: 'ASMR content converts 38% better than regular audio',
    match: 78
  }];
  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'photo':
        return <Image className="w-5 h-5 text-blue-500" data-id="element-4035" />;
      case 'video':
        return <Video className="w-5 h-5 text-red-500" data-id="element-4036" />;
      case 'audio':
        return <Mic className="w-5 h-5 text-purple-500" data-id="element-4037" />;
      default:
        return <File className="w-5 h-5 text-gray-500" data-id="element-4038" />;
    }
  };
  return <div className="space-y-6" data-id="element-4039">
      {/* Content Store Header */}
      <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-4040">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-4041">
          <div data-id="element-4042">
            <h2 className="text-xl font-bold flex items-center gap-2" data-id="element-4043">
              <ShoppingBag className="w-6 h-6 text-purple-500" data-id="element-4044" />
              Content Store & Vault
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-4045">
              Manage and sell your premium content collections
            </p>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-4046">
            <button className="px-4 py-2 bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-lg text-sm font-medium flex items-center gap-1" onClick={() => setShowUploadModal(true)} data-id="element-4047">
              <Plus className="w-4 h-4" data-id="element-4048" />
              Upload New Content
            </button>
            <button className="px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-lg text-sm font-medium flex items-center gap-1" data-id="element-4049">
              <Gift className="w-4 h-4" data-id="element-4050" />
              Create Bundle Offer
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4" data-id="element-4051">
          <div className="bg-purple-50 dark:bg-purple-900/20 p-3 rounded-lg border border-purple-100 dark:border-purple-800/30 flex items-center gap-3" data-id="element-4052">
            <div className="w-10 h-10 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center text-purple-600 dark:text-purple-400" data-id="element-4053">
              <ShoppingBag className="w-5 h-5" data-id="element-4054" />
            </div>
            <div data-id="element-4055">
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-4056">
                Total Sales
              </p>
              <p className="font-bold" data-id="element-4057">252</p>
            </div>
          </div>
          <div className="bg-green-50 dark:bg-green-900/20 p-3 rounded-lg border border-green-100 dark:border-green-800/30 flex items-center gap-3" data-id="element-4058">
            <div className="w-10 h-10 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400" data-id="element-4059">
              <DollarSign className="w-5 h-5" data-id="element-4060" />
            </div>
            <div data-id="element-4061">
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-4062">
                Total Revenue
              </p>
              <p className="font-bold" data-id="element-4063">$6,249.50</p>
            </div>
          </div>
          <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg border border-blue-100 dark:border-blue-800/30 flex items-center gap-3" data-id="element-4064">
            <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center text-blue-600 dark:text-blue-400" data-id="element-4065">
              <Lock className="w-5 h-5" data-id="element-4066" />
            </div>
            <div data-id="element-4067">
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-4068">
                Content Packs
              </p>
              <p className="font-bold" data-id="element-4069">8</p>
            </div>
          </div>
          <div className="bg-yellow-50 dark:bg-yellow-900/20 p-3 rounded-lg border border-yellow-100 dark:border-yellow-800/30 flex items-center gap-3" data-id="element-4070">
            <div className="w-10 h-10 rounded-full bg-yellow-100 dark:bg-yellow-900/30 flex items-center justify-center text-yellow-600 dark:text-yellow-400" data-id="element-4071">
              <Star className="w-5 h-5" data-id="element-4072" />
            </div>
            <div data-id="element-4073">
              <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-4074">
                Avg. Rating
              </p>
              <p className="font-bold" data-id="element-4075">4.8/5</p>
            </div>
          </div>
        </div>
      </div>
      {/* Tabs Navigation */}
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden" data-id="element-4076">
        <div className="flex border-b border-gray-200 dark:border-gray-700" data-id="element-4077">
          <button className={`flex-1 py-3 text-center font-medium text-sm relative ${activeTab === 'content-packs' ? 'text-purple-600 dark:text-purple-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => setActiveTab('content-packs')} data-id="element-4078">
            Content Packs
            {activeTab === 'content-packs' && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-purple-600 dark:bg-purple-400" data-id="element-4079"></div>}
          </button>
          <button className={`flex-1 py-3 text-center font-medium text-sm relative ${activeTab === 'analytics' ? 'text-purple-600 dark:text-purple-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => setActiveTab('analytics')} data-id="element-4080">
            Sales Analytics
            {activeTab === 'analytics' && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-purple-600 dark:bg-purple-400" data-id="element-4081"></div>}
          </button>
          <button className={`flex-1 py-3 text-center font-medium text-sm relative ${activeTab === 'suggestions' ? 'text-purple-600 dark:text-purple-400' : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'}`} onClick={() => setActiveTab('suggestions')} data-id="element-4082">
            Content Suggestions
            {activeTab === 'suggestions' && <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-purple-600 dark:bg-purple-400" data-id="element-4083"></div>}
          </button>
        </div>
        <div className="p-4" data-id="element-4084">
          {activeTab === 'content-packs' && <div className="space-y-4" data-id="element-4085">
              {/* Search and Filter */}
              <div className="flex flex-col md:flex-row gap-3 justify-between" data-id="element-4086">
                <div className="relative w-full md:w-64" data-id="element-4087">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-4088" />
                  <input type="text" placeholder="Search content packs..." className="w-full pl-10 pr-4 py-2 bg-gray-100 dark:bg-gray-700 rounded-md text-sm" data-id="element-4089" />
                </div>
                <div className="flex flex-wrap gap-2" data-id="element-4090">
                  <select className="px-3 py-2 bg-gray-100 dark:bg-gray-700 rounded-md text-sm" data-id="element-4091">
                    <option data-id="element-4092">All Types</option>
                    <option data-id="element-4093">Photos</option>
                    <option data-id="element-4094">Videos</option>
                    <option data-id="element-4095">Audio</option>
                  </select>
                  <select className="px-3 py-2 bg-gray-100 dark:bg-gray-700 rounded-md text-sm" data-id="element-4096">
                    <option data-id="element-4097">Sort by: Newest</option>
                    <option data-id="element-4098">Sort by: Best Selling</option>
                    <option data-id="element-4099">Sort by: Highest Price</option>
                    <option data-id="element-4100">Sort by: Lowest Price</option>
                  </select>
                  <button className="px-3 py-2 bg-gray-100 dark:bg-gray-700 rounded-md text-sm flex items-center gap-1" data-id="element-4101">
                    <Filter size={16} data-id="element-4102" />
                    <span data-id="element-4103">Filters</span>
                  </button>
                </div>
              </div>
              {/* Featured Content */}
              <div data-id="element-4104">
                <h3 className="font-medium mb-3" data-id="element-4105">Featured Content</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-4106">
                  {contentPacks.filter(pack => pack.featured).map(pack => <div key={pack.id} className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden shadow-sm" data-id="element-4107">
                        <div className="relative" data-id="element-4108">
                          <img src={pack.thumbnail} alt={pack.title} className="w-full h-48 object-cover" data-id="element-4109" />
                          <div className="absolute top-0 right-0 m-2" data-id="element-4110">
                            <span className="px-2 py-1 bg-purple-500 text-white text-xs font-medium rounded-md" data-id="element-4111">
                              Featured
                            </span>
                          </div>
                          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3" data-id="element-4112">
                            <div className="flex justify-between items-center" data-id="element-4113">
                              <span className="text-white text-sm font-medium" data-id="element-4114">
                                {pack.type === 'photo' ? 'Photo Pack' : pack.type === 'video' ? 'Video Pack' : 'Audio Pack'}
                              </span>
                              <span className="bg-black/50 text-white text-xs px-2 py-0.5 rounded-full" data-id="element-4115">
                                {pack.itemCount} items
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="p-3" data-id="element-4116">
                          <h4 className="font-medium" data-id="element-4117">{pack.title}</h4>
                          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1" data-id="element-4118">
                            {pack.description}
                          </p>
                          <div className="flex justify-between items-center mt-3" data-id="element-4119">
                            <span className="font-bold text-lg" data-id="element-4120">
                              ${pack.price}
                            </span>
                            <div className="flex items-center gap-1" data-id="element-4121">
                              <Star className="w-4 h-4 text-yellow-500" fill="currentColor" data-id="element-4122" />
                              <span className="text-sm" data-id="element-4123">{pack.rating}</span>
                            </div>
                          </div>
                          <div className="flex justify-between items-center mt-3 text-xs text-gray-500" data-id="element-4124">
                            <span data-id="element-4125">{pack.sales} sales</span>
                            <div className="flex items-center gap-1" data-id="element-4126">
                              <Eye className="w-3 h-3" data-id="element-4127" />
                              <span data-id="element-4128">{Math.round(pack.sales * 8.5)} views</span>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-2 mt-3" data-id="element-4129">
                            <button className="py-2 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-md text-sm font-medium" data-id="element-4130">
                              Edit
                            </button>
                            <button className="py-2 bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-md text-sm font-medium" data-id="element-4131">
                              Promote
                            </button>
                          </div>
                        </div>
                      </div>)}
                </div>
              </div>
              {/* All Content Packs */}
              <div data-id="element-4132">
                <h3 className="font-medium mb-3" data-id="element-4133">All Content Packs</h3>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-4134">
                  {contentPacks.map(pack => <div key={pack.id} className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden shadow-sm" data-id="element-4135">
                      <div className="relative" data-id="element-4136">
                        <img src={pack.thumbnail} alt={pack.title} className="w-full h-40 object-cover" data-id="element-4137" />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2" data-id="element-4138">
                          <div className="flex justify-between items-center" data-id="element-4139">
                            <span className="text-white text-xs" data-id="element-4140">
                              {pack.type === 'photo' ? 'Photo Pack' : pack.type === 'video' ? 'Video Pack' : 'Audio Pack'}
                            </span>
                            <span className="bg-black/50 text-white text-xs px-1.5 py-0.5 rounded-full" data-id="element-4141">
                              {pack.itemCount} items
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="p-3" data-id="element-4142">
                        <h4 className="font-medium text-sm" data-id="element-4143">{pack.title}</h4>
                        <div className="flex justify-between items-center mt-2" data-id="element-4144">
                          <span className="font-bold" data-id="element-4145">${pack.price}</span>
                          <div className="flex items-center gap-1" data-id="element-4146">
                            <Star className="w-3 h-3 text-yellow-500" fill="currentColor" data-id="element-4147" />
                            <span className="text-xs" data-id="element-4148">{pack.rating}</span>
                          </div>
                        </div>
                        <div className="flex justify-between items-center mt-2 text-xs text-gray-500" data-id="element-4149">
                          <span data-id="element-4150">{pack.sales} sales</span>
                          <button className="text-purple-600 dark:text-purple-400" data-id="element-4151">
                            Edit
                          </button>
                        </div>
                      </div>
                    </div>)}
                  {/* Add New Pack Card */}
                  <div className="bg-gray-50 dark:bg-gray-900 border border-dashed border-gray-300 dark:border-gray-700 rounded-lg flex flex-col items-center justify-center p-6 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors" onClick={() => setShowUploadModal(true)} data-id="element-4152">
                    <div className="w-12 h-12 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center text-purple-600 dark:text-purple-400 mb-3" data-id="element-4153">
                      <Plus className="w-6 h-6" data-id="element-4154" />
                    </div>
                    <h4 className="font-medium text-sm text-center" data-id="element-4155">
                      Create New Content Pack
                    </h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400 text-center mt-1" data-id="element-4156">
                      Upload photos, videos, or audio files
                    </p>
                  </div>
                </div>
              </div>
            </div>}
          {activeTab === 'analytics' && <div className="space-y-4" data-id="element-4157">
              {/* Sales Overview */}
              <div className="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-4158">
                <h3 className="font-medium mb-3" data-id="element-4159">Sales Overview</h3>
                <div className="flex items-end justify-center h-40" data-id="element-4160">
                  <div className="w-full h-full flex items-end justify-around" data-id="element-4161">
                    <div className="flex flex-col items-center" data-id="element-4162">
                      <div className="w-12 bg-purple-500 dark:bg-purple-600" style={{
                    height: '30%'
                  }} data-id="element-4163"></div>
                      <span className="text-xs mt-1" data-id="element-4164">Mon</span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-4165">
                      <div className="w-12 bg-purple-500 dark:bg-purple-600" style={{
                    height: '45%'
                  }} data-id="element-4166"></div>
                      <span className="text-xs mt-1" data-id="element-4167">Tue</span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-4168">
                      <div className="w-12 bg-purple-500 dark:bg-purple-600" style={{
                    height: '60%'
                  }} data-id="element-4169"></div>
                      <span className="text-xs mt-1" data-id="element-4170">Wed</span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-4171">
                      <div className="w-12 bg-purple-500 dark:bg-purple-600" style={{
                    height: '75%'
                  }} data-id="element-4172"></div>
                      <span className="text-xs mt-1" data-id="element-4173">Thu</span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-4174">
                      <div className="w-12 bg-purple-500 dark:bg-purple-600" style={{
                    height: '90%'
                  }} data-id="element-4175"></div>
                      <span className="text-xs mt-1" data-id="element-4176">Fri</span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-4177">
                      <div className="w-12 bg-purple-500 dark:bg-purple-600" style={{
                    height: '100%'
                  }} data-id="element-4178"></div>
                      <span className="text-xs mt-1" data-id="element-4179">Sat</span>
                    </div>
                    <div className="flex flex-col items-center" data-id="element-4180">
                      <div className="w-12 bg-purple-500 dark:bg-purple-600" style={{
                    height: '80%'
                  }} data-id="element-4181"></div>
                      <span className="text-xs mt-1" data-id="element-4182">Sun</span>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center mt-4" data-id="element-4183">
                  <div data-id="element-4184">
                    <span className="text-xs text-gray-500" data-id="element-4185">
                      Total Sales This Week
                    </span>
                    <p className="font-bold text-lg" data-id="element-4186">$1,245.67</p>
                  </div>
                  <div className="flex items-center gap-1 text-green-500" data-id="element-4187">
                    <ArrowUpRight className="w-4 h-4" data-id="element-4188" />
                    <span className="font-medium" data-id="element-4189">+23.5%</span>
                  </div>
                </div>
              </div>
              {/* Top Selling Content */}
              <div className="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-4190">
                <h3 className="font-medium mb-3" data-id="element-4191">Top Selling Content</h3>
                <div className="overflow-x-auto" data-id="element-4192">
                  <table className="w-full min-w-full" data-id="element-4193">
                    <thead data-id="element-4194">
                      <tr className="text-xs text-left text-gray-500 dark:text-gray-400 border-b border-gray-200 dark:border-gray-700" data-id="element-4195">
                        <th className="pb-2 font-medium" data-id="element-4196">Content Pack</th>
                        <th className="pb-2 font-medium" data-id="element-4197">Sales</th>
                        <th className="pb-2 font-medium" data-id="element-4198">Revenue</th>
                        <th className="pb-2 font-medium" data-id="element-4199">Growth</th>
                        <th className="pb-2 font-medium" data-id="element-4200">Actions</th>
                      </tr>
                    </thead>
                    <tbody data-id="element-4201">
                      {topSellingContent.map((content, index) => <tr key={content.id} className="border-b border-gray-100 dark:border-gray-800" data-id="element-4202">
                          <td className="py-3" data-id="element-4203">
                            <div className="flex items-center gap-2" data-id="element-4204">
                              <div className="w-8 h-8 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center text-purple-600 dark:text-purple-400" data-id="element-4205">
                                {index + 1}
                              </div>
                              <span className="font-medium text-sm" data-id="element-4206">
                                {content.title}
                              </span>
                            </div>
                          </td>
                          <td className="py-3" data-id="element-4207">
                            <span className="text-sm" data-id="element-4208">{content.sales}</span>
                          </td>
                          <td className="py-3" data-id="element-4209">
                            <span className="text-sm font-medium" data-id="element-4210">
                              ${content.revenue.toFixed(2)}
                            </span>
                          </td>
                          <td className="py-3" data-id="element-4211">
                            <span className="text-sm text-green-500" data-id="element-4212">
                              {content.growth}
                            </span>
                          </td>
                          <td className="py-3" data-id="element-4213">
                            <button className="px-3 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-md text-xs font-medium" data-id="element-4214">
                              Promote
                            </button>
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* Customer Insights */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-4215">
                <div className="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-4216">
                  <h3 className="font-medium mb-3" data-id="element-4217">Customer Demographics</h3>
                  <div className="flex justify-center items-center h-40" data-id="element-4218">
                    <div className="w-40 h-40 rounded-full border-8 border-purple-200 dark:border-purple-900/30 flex items-center justify-center relative" data-id="element-4219">
                      <div className="absolute inset-0" style={{
                    borderRightColor: 'transparent',
                    transform: 'rotate(-45deg)'
                  }} data-id="element-4220"></div>
                      <div className="absolute inset-0" style={{
                    borderBottomColor: 'transparent',
                    borderLeftColor: 'transparent',
                    transform: 'rotate(45deg)'
                  }} data-id="element-4221"></div>
                      <div className="text-center" data-id="element-4222">
                        <span className="block text-lg font-bold" data-id="element-4223">75%</span>
                        <span className="text-xs text-gray-500" data-id="element-4224">Male</span>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-2 mt-3" data-id="element-4225">
                    <div className="p-2 bg-gray-50 dark:bg-gray-800 rounded-md" data-id="element-4226">
                      <span className="text-xs text-gray-500 block" data-id="element-4227">
                        Age Range
                      </span>
                      <span className="font-medium" data-id="element-4228">25-34 (68%)</span>
                    </div>
                    <div className="p-2 bg-gray-50 dark:bg-gray-800 rounded-md" data-id="element-4229">
                      <span className="text-xs text-gray-500 block" data-id="element-4230">
                        Top Location
                      </span>
                      <span className="font-medium" data-id="element-4231">United States</span>
                    </div>
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-4232">
                  <h3 className="font-medium mb-3" data-id="element-4233">Purchase Patterns</h3>
                  <div className="space-y-3" data-id="element-4234">
                    <div data-id="element-4235">
                      <div className="flex justify-between text-xs mb-1" data-id="element-4236">
                        <span data-id="element-4237">Video Content</span>
                        <span data-id="element-4238">68%</span>
                      </div>
                      <div className="w-full h-2 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-4239">
                        <div className="h-full bg-red-500 rounded-full" style={{
                      width: '68%'
                    }} data-id="element-4240"></div>
                      </div>
                    </div>
                    <div data-id="element-4241">
                      <div className="flex justify-between text-xs mb-1" data-id="element-4242">
                        <span data-id="element-4243">Photo Content</span>
                        <span data-id="element-4244">24%</span>
                      </div>
                      <div className="w-full h-2 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-4245">
                        <div className="h-full bg-blue-500 rounded-full" style={{
                      width: '24%'
                    }} data-id="element-4246"></div>
                      </div>
                    </div>
                    <div data-id="element-4247">
                      <div className="flex justify-between text-xs mb-1" data-id="element-4248">
                        <span data-id="element-4249">Audio Content</span>
                        <span data-id="element-4250">8%</span>
                      </div>
                      <div className="w-full h-2 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-4251">
                        <div className="h-full bg-purple-500 rounded-full" style={{
                      width: '8%'
                    }} data-id="element-4252"></div>
                      </div>
                    </div>
                  </div>
                  <div className="p-2 bg-blue-50 dark:bg-blue-900/20 rounded-md mt-3 text-xs text-blue-700 dark:text-blue-400" data-id="element-4253">
                    <span className="font-medium" data-id="element-4254">Insight:</span> Video content
                    sells 2.8x better than photos. Consider creating more video
                    packs.
                  </div>
                </div>
              </div>
            </div>}
          {activeTab === 'suggestions' && <div className="space-y-4" data-id="element-4255">
              {/* AI Content Suggestions */}
              <div className="bg-gradient-to-r from-purple-50 to-pink-50 dark:from-purple-900/20 dark:to-pink-900/20 p-4 rounded-lg border border-purple-100 dark:border-purple-800/30" data-id="element-4256">
                <div className="flex items-center gap-2 mb-4" data-id="element-4257">
                  <Sparkles className="w-5 h-5 text-purple-600 dark:text-purple-400" data-id="element-4258" />
                  <h3 className="font-medium" data-id="element-4259">AI Content Suggestions</h3>
                </div>
                <div className="space-y-3" data-id="element-4260">
                  {contentSuggestions.map((suggestion, index) => <div key={index} className="p-3 bg-white dark:bg-gray-800 rounded-lg" data-id="element-4261">
                      <div className="flex justify-between items-start" data-id="element-4262">
                        <h4 className="font-medium text-sm" data-id="element-4263">
                          {suggestion.title}
                        </h4>
                        <span className="text-xs px-2 py-0.5 bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-full" data-id="element-4264">
                          {suggestion.match}% match
                        </span>
                      </div>
                      <p className="text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-4265">
                        {suggestion.description}
                      </p>
                      <button className="mt-2 px-3 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-md text-xs font-medium" data-id="element-4266">
                        Create Content
                      </button>
                    </div>)}
                </div>
              </div>
              {/* Content Gap Analysis */}
              <div className="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-4267">
                <h3 className="font-medium mb-3" data-id="element-4268">Content Gap Analysis</h3>
                <div className="space-y-3" data-id="element-4269">
                  <div className="p-3 bg-gray-50 dark:bg-gray-800 rounded-lg flex items-start gap-3" data-id="element-4270">
                    <div className="w-8 h-8 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center text-red-600 dark:text-red-400" data-id="element-4271">
                      <Video className="w-4 h-4" data-id="element-4272" />
                    </div>
                    <div className="flex-1" data-id="element-4273">
                      <h4 className="font-medium text-sm" data-id="element-4274">
                        Missing: Shower Content
                      </h4>
                      <p className="text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-4275">
                        12 users have searched for "shower" content in the last
                        week, but you don't have any available.
                      </p>
                      <button className="mt-2 px-3 py-1 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-md text-xs font-medium" data-id="element-4276">
                        Fill Content Gap
                      </button>
                    </div>
                  </div>
                  <div className="p-3 bg-gray-50 dark:bg-gray-800 rounded-lg flex items-start gap-3" data-id="element-4277">
                    <div className="w-8 h-8 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center text-blue-600 dark:text-blue-400" data-id="element-4278">
                      <Image className="w-4 h-4" data-id="element-4279" />
                    </div>
                    <div className="flex-1" data-id="element-4280">
                      <h4 className="font-medium text-sm" data-id="element-4281">
                        Missing: Cosplay Content
                      </h4>
                      <p className="text-xs text-gray-600 dark:text-gray-400 mt-1" data-id="element-4282">
                        8 users have searched for "cosplay" content in the last
                        week, but you don't have any available.
                      </p>
                      <button className="mt-2 px-3 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-md text-xs font-medium" data-id="element-4283">
                        Fill Content Gap
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* Popular Search Terms */}
              <div className="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-4284">
                <h3 className="font-medium mb-3" data-id="element-4285">Popular Search Terms</h3>
                <div className="flex flex-wrap gap-2" data-id="element-4286">
                  <div className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-sm flex items-center gap-1" data-id="element-4287">
                    <span data-id="element-4288">lingerie</span>
                    <span className="text-xs bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 px-1.5 py-0.5 rounded-full" data-id="element-4289">
                      24
                    </span>
                  </div>
                  <div className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-sm flex items-center gap-1" data-id="element-4290">
                    <span data-id="element-4291">shower</span>
                    <span className="text-xs bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 px-1.5 py-0.5 rounded-full" data-id="element-4292">
                      18
                    </span>
                  </div>
                  <div className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-sm flex items-center gap-1" data-id="element-4293">
                    <span data-id="element-4294">bedroom</span>
                    <span className="text-xs bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 px-1.5 py-0.5 rounded-full" data-id="element-4295">
                      15
                    </span>
                  </div>
                  <div className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-sm flex items-center gap-1" data-id="element-4296">
                    <span data-id="element-4297">cosplay</span>
                    <span className="text-xs bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 px-1.5 py-0.5 rounded-full" data-id="element-4298">
                      12
                    </span>
                  </div>
                  <div className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-sm flex items-center gap-1" data-id="element-4299">
                    <span data-id="element-4300">workout</span>
                    <span className="text-xs bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 px-1.5 py-0.5 rounded-full" data-id="element-4301">
                      10
                    </span>
                  </div>
                  <div className="px-3 py-1.5 bg-gray-100 dark:bg-gray-800 rounded-full text-sm flex items-center gap-1" data-id="element-4302">
                    <span data-id="element-4303">asmr</span>
                    <span className="text-xs bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 px-1.5 py-0.5 rounded-full" data-id="element-4304">
                      8
                    </span>
                  </div>
                </div>
              </div>
              {/* Seasonal Content Recommendations */}
              <div className="bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700" data-id="element-4305">
                <h3 className="font-medium mb-3" data-id="element-4306">
                  Seasonal Content Recommendations
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-4307">
                  <div className="p-3 bg-gradient-to-br from-red-50 to-pink-50 dark:from-red-900/20 dark:to-pink-900/20 rounded-lg border border-red-100 dark:border-red-800/30" data-id="element-4308">
                    <div className="flex items-center gap-2 mb-2" data-id="element-4309">
                      <div className="w-8 h-8 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center text-red-600 dark:text-red-400" data-id="element-4310">
                        <span data-id="element-4311">❤️</span>
                      </div>
                      <h4 className="font-medium text-sm" data-id="element-4312">Valentine's Day</h4>
                    </div>
                    <p className="text-xs text-gray-600 dark:text-gray-400 mb-2" data-id="element-4313">
                      Create a romantic themed content pack for Valentine's Day.
                    </p>
                    <button className="w-full py-1.5 bg-red-100 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-md text-xs font-medium" data-id="element-4314">
                      Plan Content
                    </button>
                  </div>
                  <div className="p-3 bg-gradient-to-br from-orange-50 to-yellow-50 dark:from-orange-900/20 dark:to-yellow-900/20 rounded-lg border border-orange-100 dark:border-orange-800/30" data-id="element-4315">
                    <div className="flex items-center gap-2 mb-2" data-id="element-4316">
                      <div className="w-8 h-8 rounded-full bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center text-orange-600 dark:text-orange-400" data-id="element-4317">
                        <span data-id="element-4318">🎃</span>
                      </div>
                      <h4 className="font-medium text-sm" data-id="element-4319">Halloween</h4>
                    </div>
                    <p className="text-xs text-gray-600 dark:text-gray-400 mb-2" data-id="element-4320">
                      Plan a spooky costume photo/video set for Halloween.
                    </p>
                    <button className="w-full py-1.5 bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-400 rounded-md text-xs font-medium" data-id="element-4321">
                      Plan Content
                    </button>
                  </div>
                  <div className="p-3 bg-gradient-to-br from-green-50 to-teal-50 dark:from-green-900/20 dark:to-teal-900/20 rounded-lg border border-green-100 dark:border-green-800/30" data-id="element-4322">
                    <div className="flex items-center gap-2 mb-2" data-id="element-4323">
                      <div className="w-8 h-8 rounded-full bg-green-100 dark:bg-green-900/30 flex items-center justify-center text-green-600 dark:text-green-400" data-id="element-4324">
                        <span data-id="element-4325">🎄</span>
                      </div>
                      <h4 className="font-medium text-sm" data-id="element-4326">Christmas</h4>
                    </div>
                    <p className="text-xs text-gray-600 dark:text-gray-400 mb-2" data-id="element-4327">
                      Create a festive holiday-themed content collection.
                    </p>
                    <button className="w-full py-1.5 bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 rounded-md text-xs font-medium" data-id="element-4328">
                      Plan Content
                    </button>
                  </div>
                </div>
              </div>
            </div>}
        </div>
      </div>
      {/* Upload Modal */}
      {showUploadModal && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" data-id="element-4329">
          <div className="bg-white dark:bg-gray-900 rounded-xl shadow-xl w-full max-w-lg max-h-[90vh] overflow-hidden" data-id="element-4330">
            <div className="p-4 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between" data-id="element-4331">
              <h3 className="font-bold flex items-center gap-2" data-id="element-4332">
                <Plus className="w-5 h-5 text-purple-500" data-id="element-4333" />
                Create New Content Pack
              </h3>
              <button onClick={() => setShowUploadModal(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-4334">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5" data-id="element-4335">
                  <path d="M18 6 6 18" data-id="element-4336" />
                  <path d="m6 6 12 12" data-id="element-4337" />
                </svg>
              </button>
            </div>
            <div className="p-4" data-id="element-4338">
              <div className="space-y-4" data-id="element-4339">
                <div data-id="element-4340">
                  <label className="block text-sm font-medium mb-1" data-id="element-4341">
                    Pack Title
                  </label>
                  <input type="text" placeholder="e.g. Summer Beach Collection" className="w-full p-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md text-sm" data-id="element-4342" />
                </div>
                <div data-id="element-4343">
                  <label className="block text-sm font-medium mb-1" data-id="element-4344">
                    Description
                  </label>
                  <textarea placeholder="Describe your content pack..." rows={3} className="w-full p-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md text-sm" data-id="element-4345"></textarea>
                </div>
                <div data-id="element-4346">
                  <label className="block text-sm font-medium mb-1" data-id="element-4347">
                    Content Type
                  </label>
                  <div className="grid grid-cols-3 gap-2" data-id="element-4348">
                    <button className="p-3 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg flex flex-col items-center gap-1" data-id="element-4349">
                      <Image className="w-5 h-5" data-id="element-4350" />
                      <span className="text-xs font-medium" data-id="element-4351">Photos</span>
                    </button>
                    <button className="p-3 bg-gray-100 dark:bg-gray-800 rounded-lg flex flex-col items-center gap-1" data-id="element-4352">
                      <Video className="w-5 h-5" data-id="element-4353" />
                      <span className="text-xs font-medium" data-id="element-4354">Videos</span>
                    </button>
                    <button className="p-3 bg-gray-100 dark:bg-gray-800 rounded-lg flex flex-col items-center gap-1" data-id="element-4355">
                      <Mic className="w-5 h-5" data-id="element-4356" />
                      <span className="text-xs font-medium" data-id="element-4357">Audio</span>
                    </button>
                  </div>
                </div>
                <div data-id="element-4358">
                  <label className="block text-sm font-medium mb-1" data-id="element-4359">
                    Price
                  </label>
                  <div className="relative" data-id="element-4360">
                    <DollarSign className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} data-id="element-4361" />
                    <input type="text" placeholder="29.99" className="w-full pl-10 pr-4 py-2 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md text-sm" data-id="element-4362" />
                  </div>
                </div>
                <div data-id="element-4363">
                  <label className="block text-sm font-medium mb-1" data-id="element-4364">
                    Upload Content
                  </label>
                  <div className="border-2 border-dashed border-gray-300 dark:border-gray-700 rounded-lg p-6 text-center" data-id="element-4365">
                    <div className="mx-auto w-12 h-12 rounded-full bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center text-purple-600 dark:text-purple-400 mb-3" data-id="element-4366">
                      <Camera className="w-6 h-6" data-id="element-4367" />
                    </div>
                    <p className="text-sm text-gray-500 dark:text-gray-400 mb-2" data-id="element-4368">
                      Drag and drop your files here, or click to browse
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-4369">
                      Supports JPG, PNG, MP4, MOV, MP3
                    </p>
                    <button className="mt-3 px-4 py-2 bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-md text-sm font-medium" data-id="element-4370">
                      Select Files
                    </button>
                  </div>
                </div>
                <div className="flex justify-between items-center pt-3 border-t border-gray-200 dark:border-gray-800" data-id="element-4371">
                  <button className="px-4 py-2 bg-gray-100 dark:bg-gray-800 rounded-md text-sm font-medium" onClick={() => setShowUploadModal(false)} data-id="element-4372">
                    Cancel
                  </button>
                  <button className="px-4 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-md text-sm font-medium" data-id="element-4373">
                    Create Content Pack
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}